import React from "react";
import { Box } from "@mui/material";
import { DotLegalCheckbox, DotLegalHeader, DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useAnnualWheelDialogStyles } from "../annualWheelDialog/AnnualWheelDialog.styles.ts";
import { useTranslation } from "../../localization/useTranslation.ts";
import { DotLegalSelectOption } from "../../common/components/dotLegalMultiSelect/DotLegalMultiSelect.types.ts";
import DotLegalSection from "../../common/components/dotLegalSection/DotLegalSection.tsx";

export interface RecurrenceSectionProps {
    interval: number | null | undefined;
    intervalType: string | number | undefined | null;

    intervalTypeOptions: Array<DotLegalSelectOption>;

    onIntervalChange: (value: string) => void;
    onIntervalTypeChange: (value: string) => void;
    onSingularChange?: (checked: boolean) => void; // optional; if omitted, the singular checkbox is hidden

    showError?: boolean;
    isIntervalInvalid?: boolean;

    showSingularCheckbox?: boolean;
    readOnly?: boolean;
}

const RecurrenceSection: React.FC<RecurrenceSectionProps> = (props) => {
    const styles = useAnnualWheelDialogStyles();
    const { translateString } = useTranslation();

    const disable = props.readOnly || props.interval === null;
    const showSingular = props.showSingularCheckbox ?? !!props.onSingularChange;

    return (
        <>
            <DotLegalHeader headerStyle={"small"} marginTop={3} marginBottom={0.5}>
                {translateString("annualWheelTaskCompleted")}
            </DotLegalHeader>

            <DotLegalSection>
                <Box sx={styles.interval}>
                    <Box component={"span"} sx={styles.each}>
                        {translateString("recursEvery")}
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box sx={styles.numberField}>
                            <DotLegalTextField
                                onlyNumber={"integer"}
                                label={""}
                                value={props.interval?.toString() ?? null}
                                debounce={false}
                                noMargin
                                onChange={props.onIntervalChange}
                                disabled={disable}
                            />
                        </Box>
                        <DotLegalSelect
                            selectedItem={props.intervalType?.toString() ?? ""}
                            options={props.intervalTypeOptions}
                            onChange={(type) => props.onIntervalTypeChange(type!)}
                            label={""}
                            placeholder={translateString("period")}
                            noOptionsLabel={translateString("noOptions")}
                            disableClearable
                            noMargin
                            width={"150px"}
                            disabled={disable}
                        />
                    </Box>
                </Box>

                {props.showError && props.isIntervalInvalid && (
                    <Box sx={styles.error}>
                        {!props.interval || `${props.interval}`.trim() === "" ? translateString("fieldRequired") : translateString("invalidValue")}
                    </Box>
                )}

                {showSingular && (
                    <Box sx={styles.singularActivity}>
                        <DotLegalCheckbox
                            label={translateString("annualWheelActivitySingular")}
                            checked={props.interval === null}
                            onChange={(value) => props.onSingularChange && props.onSingularChange(value)}
                            margin={{ marginLeft: -1.5 }}
                            disabled={props.readOnly}
                        />
                    </Box>
                )}
            </DotLegalSection>
        </>
    );
};

export default RecurrenceSection;
